const formatValue = (value) => (value ? Number(value).toLocaleString() : "-");

const mapRows = (rows = []) =>
  rows
    .filter((row) => row.campus !== "OVERALL")
    .map((row) => ({
      campus: row.campus,
      supply: row.supply,
      ay2025: row.AY20252026,
      ay2026: row.AY20262027,
      overall: row.overall,
    }));

const getTotals = (rows = []) => {
  const totalRow = rows.find((row) => row.campus === "OVERALL");

  return {
    supply: totalRow?.supply || 0,
    ay2025: totalRow?.AY20252026 || 0,
    ay2026: totalRow?.AY20262027 || 0,
    overall: totalRow?.overall || 0,
  };
};

const Activities = ({ data = [] }) => {
  const rows = mapRows(data);
  const totals = getTotals(data);

  return (
    <div className="overflow-hidden rounded-3xl bg-white shadow-sm">
      <div className="border-b border-slate-200 px-6 py-5">
        <h2 className="text-2xl font-bold text-indigo-950">
          Admissions Pipeline
        </h2>
      </div>

      <div>
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b border-slate-200 text-left bg-slate-50/50">
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500">Campus</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right">Supply</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right">AY 2025-26</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right">AY 2026-27</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right">Overall</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row) => (
                <tr
                  key={row.campus}
                  className="border-b border-slate-100 transition-colors hover:bg-blue-50/50"
                >
                  <td className="px-4 py-3 text-sm font-medium text-slate-700">{row.campus}</td>
                  <td className="px-4 py-3 text-sm text-slate-600 text-right">{formatValue(row.supply)}</td>
                  <td className="px-4 py-3 text-sm text-slate-600 text-right">{formatValue(row.ay2025)}</td>
                  <td className="px-4 py-3 text-sm text-slate-600 text-right">{formatValue(row.ay2026)}</td>
                  <td className="px-4 py-3 text-sm font-semibold text-slate-700 text-right">{formatValue(row.overall)}</td>
                </tr>
            ))}
          </tbody>

          <tfoot>
            <tr className="bg-blue-600 text-white">
              <td className="px-4 py-3 text-sm font-bold uppercase tracking-wider">Overall</td>
              <td className="px-4 py-3 text-sm font-bold text-right">{formatValue(totals.supply)}</td>
              <td className="px-4 py-3 text-sm font-bold text-right">{formatValue(totals.ay2025)}</td>
              <td className="px-4 py-3 text-sm font-bold text-right">{formatValue(totals.ay2026)}</td>
              <td className="px-4 py-3 text-sm font-bold text-right">{formatValue(totals.overall)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default Activities;
